// Bestelronde- en levering-I/O (epic 3). Thin wrappers rond de Postgres-RPC's; de
// immutabiliteit + atomaire writes leven in de DB (migr 074). Ge-barreld via api.ts.
import { supabase } from '../supabase';

export interface OrderRound {
  id: string;
  supplier_id: string;
  status: 'draft' | 'sent';
  order_date: string | null;
  sent_at: string | null;
  sent_by: string | null;
  created_at: string;
}

/** Maakt (of hergebruikt) een open bestelronde voor een leverancier. */
export async function createOrderRound(supplierId: string): Promise<OrderRound> {
  const { data, error } = await supabase
    .from('gift_order_rounds')
    .insert({ supplier_id: supplierId, status: 'draft' })
    .select('*')
    .single();
  if (error) throw error;
  return data as OrderRound;
}

export async function fetchOpenRound(supplierId: string): Promise<OrderRound | null> {
  const { data, error } = await supabase
    .from('gift_order_rounds')
    .select('*')
    .eq('supplier_id', supplierId)
    .eq('status', 'draft')
    .order('created_at', { ascending: false })
    .limit(1);
  if (error) throw error;
  return (data?.[0] as OrderRound) ?? null;
}

export async function fetchRounds(): Promise<OrderRound[]> {
  const { data, error } = await supabase
    .from('gift_order_rounds')
    .select('*')
    .order('created_at', { ascending: false });
  if (error) throw error;
  return (data as OrderRound[]) ?? [];
}

/** Koppelt een inkooporder aan een open ronde (alleen toegestaan zolang draft). */
export async function assignPurchaseOrderToRound(poId: string, roundId: string): Promise<void> {
  const { error } = await supabase
    .from('gift_purchase_orders')
    .update({ order_round_id: roundId })
    .eq('id', poId);
  if (error) throw error;
}

/** Plaatst de ronde: bevriest + denormaliseert, atomair (RPC lock_order_round). */
export async function lockOrderRound(roundId: string): Promise<void> {
  const { error } = await supabase.rpc('lock_order_round', { p_round_id: roundId });
  if (error) throw error;
}

/** Past de bestelhoeveelheden van een inkoopregel aan (na voorraad-gebruik, FR-7.7). */
export async function updatePurchaseOrderItemQuantities(
  itemId: string,
  fields: { total_units_ordered: number; vpe_units_ordered: number; leftover_units: number }
): Promise<void> {
  const { error } = await supabase
    .from('gift_purchase_order_items')
    .update(fields)
    .eq('id', itemId);
  if (error) throw error;
}

/** Verwerkt levering van een inkooporder: status delivered + restvoorraad (RPC record_delivery). */
export async function recordDelivery(
  purchaseOrderId: string,
  deliveredQty?: number
): Promise<void> {
  const { error } = await supabase.rpc('record_delivery', {
    p_purchase_order_id: purchaseOrderId,
    p_delivered_qty: deliveredQty ?? null,
  });
  if (error) throw error;
}
